<template>
  <header class="hvh-header">
    <a v-once :href="hvhUrl" class="hvh-header__logo mr-3">
      <img src="/fixed-hvh/img/logo_actics.svg" alt="ACTICS logo BY EVERSANA" />
    </a>
    <a v-once :href="scipherUrl" class="hvh-header__logo-scipher">
      <img src="/fixed-hvh/img/logo_scipheraccess.svg" alt="Scipher Access" />
    </a>
    <slot></slot>
  </header>
</template>

<script  >

export default {
  props: ['hvhUrl', 'scipherUrl'],
}
</script>

<style lang="scss">
.hvh-header {
  align-items: stretch;
  background-color: $color-white;
  box-shadow: 0 0 10px 0 $color-shadow-default;
  display: flex;
  position: fixed;
  z-index: 2;

  a {
    display: flex;
    vertical-align: center;
    align-items: center;
  }
}

.hvh-header__logo {
  background-color: $color-dark-blue;
  padding: 0 rem(35px) 0 rem(20px);
  position: relative;
  overflow: hidden;
  flex: 0 0 auto;
  width: rem(190px);

  &::after {
    content: '';
    width: 0;
    height: 0;
    margin-top: rem(-50px);
    top: 50%;
    border-top: rem(50px) solid $color-white;
    border-bottom: rem(50px) solid $color-white;
    border-left: rem(20px) solid $color-dark-blue;
    position: absolute;
    right: 0;
  }

  img {
    height: 50%;
  }
}

.hvh-header__logo-scipher {
  min-width: rem(100px);
}
</style>
